import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { AuthService } from 'auth-app-lib';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { GlobalAppService } from './shared/services/global-app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'winkel';
  subscription: Subscription = new Subscription();

  constructor(
    private globalAppService: GlobalAppService,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private analytics: AngularFireAnalytics,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.addSvgIcons();
    this.handleRedirectOnReload();
    this.subscription.add(this.authService.authHandleRedirect().subscribe());

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private handleRedirectOnReload() {
    this.subscription.add(
      this.router.events
        .pipe(
          filter((rs): rs is NavigationStart => rs instanceof NavigationStart)
        )
        .subscribe((event) => {
          this.analytics.logEvent('navigation', { pageId: event.url });
          if (event.id === 1) {
            if (event.url != '/' && event.url !== '/auth/login') {

              this.globalAppService.currentUrl = event.url;
              this.authService.guardRedirectUrl = event.url;

            }
          }
        })
    );
  }


  private addSvgIcons() {
    this.matIconRegistry.addSvgIcon(
      'facebook',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/facebook.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'twitter',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/twitter.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'instagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/instagram.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'linkedin',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/linkedin.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'whatsapp',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/whatsapp.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'google-play',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/google-play.svg'
      )
    );
  }
}
